import { VersionConfig } from '@app/core/services/version-config';

export interface State {
  config: VersionConfig | null;
}

export const initialState: State = {
  config: null,
};
